import React, { Fragment } from 'react'
import { gtmEvent } from '../Services/DataLayerAddOrRemoveCart'

const QuantityChanger = ({ quantity, updateQuantity, rowSystemId }) => {
    return (
        <Fragment>
            <div className="quantity-changer">
                <div
                    className="quantity-changer__button"
                    onClick={() => {
                        quantity > 1 && updateQuantity(Number(quantity) - 1),
                            gtmEvent('remove', rowSystemId)
                    }}
                >
                    &ndash;
                </div>
                <div className="quantity-changer__quantity-text">
                    {quantity}
                </div>
                <div
                    className="quantity-changer__button"
                    onClick={() => {
                        updateQuantity(Number(quantity) + 1),
                            gtmEvent('add', rowSystemId)
                    }}
                >
                    +
                </div>
            </div>
        </Fragment>
    )
}

export default QuantityChanger
